import Promise from 'bluebird';
import { useMemo } from 'react';

const DEFAULT_DEBOUNCE_TIMEOUT_IN_MS = 500;

function debounce(f, interval) {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(
        () => resolve(f(...args)),
        interval
      );
    }).finally(() => {
      // Ajax already logs error message
      // This finally body is to by pass unhandled error from Promise
    });
  };
}

export const useDebouncedDispatch = dispatch => useMemo(
  () => debounce(dispatch, DEFAULT_DEBOUNCE_TIMEOUT_IN_MS),
  [dispatch]
);
